module.exports = __webpack_public_path__ + "img/3-4.096554b7.png";